import { ApiTagsEnum }                      from "src/constants/api-tags";
import { ENDPOINTS }                        from "src/constants/api/api";
import { api }                              from "src/store/services/api";
import type { IUpdateDeveloperNoteRequest } from "src/store/services/developer/interfaces/requests.interface";
import type { IDeveloperOptionResponse, IGetDeveloperProfileResponse,
  IUpdateDevelopersNoteResponse, } from "src/store/services/developer/interfaces/responses.interface";

export const developerApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getDeveloperProfile: builder.query<IGetDeveloperProfileResponse, number>({
      query: (id: number) => ({
        url   : `${ENDPOINTS.HIRING.GET_HIRING}/${id}`,
        method: "GET",
      }),
      providesTags: [ApiTagsEnum.DEVELOPER],
    }),

    updateDeveloperNote: builder.mutation<
      IUpdateDevelopersNoteResponse,
      IUpdateDeveloperNoteRequest
    >({
      query: (body) => ({
        url   : "/users-note",
        method: "POST",
        body,
      }),
      invalidatesTags: [ApiTagsEnum.DEVELOPER],
    }),

    getAdminDeveloperOptions: builder.query<IDeveloperOptionResponse[], void>({
      query: () => ({
        url   : ENDPOINTS.ADMIN.DEVS.OPTIONS,
        method: "GET",
      }),
      providesTags: [ApiTagsEnum.DEVELOPER],
    }),
  }),
});

export const { useGetAdminDeveloperOptionsQuery,
  useGetDeveloperProfileQuery,
  useUpdateDeveloperNoteMutation, } = developerApi;
